// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-dd-items {
  display: table;
  list-style: none;
  padding: 0px;
  background: white;
  border: 1px solid rgba(88, 89, 91, 1);
  border-top: 10px solid rgba(0, 126, 167, 1);
  z-index: 1;
  width: 600px;
  padding: 10px;
  position: relative;
  right: 572px;
}
.notifications-title-container {
  display: flex;
}
.notifications-title {
  margin-left: 220px;
}
.notifications-selected {
  cursor: pointer;
  align-items: center;
  display: flex;
  background: rgba(0, 126, 167, 1);
  justify-content: center;
  margin-left: -4px;
  height: 100%;
  margin-top: -2px;
}
.notifications-parent {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  margin-left: 6px;
  width: 28px;
  height: 28px;
}
.notifications-badge {
  position: absolute;
  cursor: pointer;
  top: -6px;
  right: -8px;
  background: #cc7e00;
  color: white;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  text-align: center;
  border-radius: 0.25rem;
  min-height: 14px;
}
.notification-message-div {
  height: 200px;
  overflow-y: auto;
  padding-left: 5px;
}

.notification-progress-track {
  width: 100%;
  height: 6px;
  background: rgba(88, 89, 91, 0.2);
  border-radius: 3px;
  overflow: hidden;
  margin-top: 4px;
}

.notification-progress-fill {
  height: 100%;
  background: rgba(0, 126, 167, 1);
  border-radius: 3px;
  transition: width 0.4s ease;
}

.notification-progress-fill.indeterminate {
  width: 40%;
  animation: progress-indeterminate 1.4s ease-in-out infinite;
}

@keyframes progress-indeterminate {
  0%   { margin-left: -40%; }
  100% { margin-left: 100%; }
}

.notification-status-step {
  font-size: 12px;
  color: rgba(0, 126, 167, 1);
  margin-top: 2px;
}

.notifications-icon-selected {
  fill: white !important;
  /* margin-top: 5px; */
}

.notifications {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/notifications/style.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,2DAA2D;AAC7D;;AAEA;EACE,OAAO,iBAAiB,EAAE;EAC1B,OAAO,iBAAiB,EAAE;AAC5B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".notifications-dd-items {\n  display: table;\n  list-style: none;\n  padding: 0px;\n  background: white;\n  border: 1px solid rgba(88, 89, 91, 1);\n  border-top: 10px solid rgba(0, 126, 167, 1);\n  z-index: 1;\n  width: 600px;\n  padding: 10px;\n  position: relative;\n  right: 572px;\n}\n.notifications-title-container {\n  display: flex;\n}\n.notifications-title {\n  margin-left: 220px;\n}\n.notifications-selected {\n  cursor: pointer;\n  align-items: center;\n  display: flex;\n  background: rgba(0, 126, 167, 1);\n  justify-content: center;\n  margin-left: -4px;\n  height: 100%;\n  margin-top: -2px;\n}\n.notifications-parent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 6px;\n  margin-left: 6px;\n  width: 28px;\n  height: 28px;\n}\n.notifications-badge {\n  position: absolute;\n  cursor: pointer;\n  top: -6px;\n  right: -8px;\n  background: #cc7e00;\n  color: white;\n  font-size: 10px;\n  font-weight: 700;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  text-align: center;\n  border-radius: 0.25rem;\n  min-height: 14px;\n}\n.notification-message-div {\n  height: 200px;\n  overflow-y: auto;\n  padding-left: 5px;\n}\n\n.notification-progress-track {\n  width: 100%;\n  height: 6px;\n  background: rgba(88, 89, 91, 0.2);\n  border-radius: 3px;\n  overflow: hidden;\n  margin-top: 4px;\n}\n\n.notification-progress-fill {\n  height: 100%;\n  background: rgba(0, 126, 167, 1);\n  border-radius: 3px;\n  transition: width 0.4s ease;\n}\n\n.notification-progress-fill.indeterminate {\n  width: 40%;\n  animation: progress-indeterminate 1.4s ease-in-out infinite;\n}\n\n@keyframes progress-indeterminate {\n  0%   { margin-left: -40%; }\n  100% { margin-left: 100%; }\n}\n\n.notification-status-step {\n  font-size: 12px;\n  color: rgba(0, 126, 167, 1);\n  margin-top: 2px;\n}\n\n.notifications-icon-selected {\n  fill: white !important;\n  /* margin-top: 5px; */\n}\n\n.notifications {\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
